<div class="row">
    <div class="col-12" *ngIf="interactions.length">
        <ul class="list-group">
            <li class="list-group-item" *ngFor="let interaction of interactions">
                <app-interaction-list-item [interaction]="interaction" [routerLink]="['./', interaction.id]"></app-interaction-list-item>
            </li>
        </ul>
    </div>
    <div class="col-12" *ngIf="!interactions.length">
        Non hai ancora creato nessuna Interaction.&nbsp;<a href="/interactions/new">Crea la tua prima Interaction.</a>
    </div>
    <div class="col-sm-12 d-flex justify-content-end mt-5">
        <button type="button" class="btn btn-primary" [routerLink]="['./new']">AGGIUNGI NUOVA INTERACTION</button>
    </div>
    <div class="col-12" *ngIf="lastExp">
        <p><a href="javascript:;" [routerLink]="['/experiences', lastExp.id]">Torna a completare l'experience {{lastExp.title}}</a></p>
    </div>
</div>